import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Fragment } from "react";
import { ResidentialZone, Scenario } from "src/types";
import { PaneListEmptyPlaceholder } from "./PaneListEmptyPlaceholder";
import { ResidentialZoneListItem } from "./ResidentialZoneListItem";

interface Props {
  scenario: Scenario;
  data: ResidentialZone[];
}

export function ResidentialZoneList(props: Props) {
  const { scenario, data } = props;
  const { t } = useTranslation();
  return render();

  function render() {
    if (!data || !scenario) return null;

    if (data.length === 0) {
      return (
        <Grid item xs={12}>
          <PaneListEmptyPlaceholder>{t("label.noResidentialZoneFound")}</PaneListEmptyPlaceholder>
        </Grid>
      );
    }

    return (
      <Fragment>
        {data.map((residentialZone) => (
          <Grid item xs={12} key={residentialZone.id}>
            <ResidentialZoneListItem residentialZone={residentialZone} scenario={scenario} />
          </Grid>
        ))}
      </Fragment>
    );
  }
}
